import {Component, Input, OnInit} from '@angular/core';
import {ProjectActivity} from '../../../../project-misc/data/project/activity/project-activity';
import {
  ProjectWindowComponent
} from '../../../../../../../../desktop/src/app/modules/project/view/project-window/project-window.component';
import {MatDialog} from '@angular/material/dialog';
import {ProjectActivityService} from '../../../../project-misc/data/project/activity/project-activity.service';

@Component({
  selector: 'app-activity-route',
  templateUrl: './activity-route.component.html',
  styleUrls: ['./activity-route.component.scss']
})
export class ActivityRouteComponent implements OnInit {

  @Input()
  activity: ProjectActivity

  @Input()
  inVehicle = false;

  constructor(
    protected matDialog: MatDialog,
    protected projectActivityService: ProjectActivityService
  ) {
  }

  ngOnInit(): void {
  }

  openProject(projectId: number) {
    const dialogRef = this.matDialog.open(ProjectWindowComponent, {
      data: {
        projectNumber: projectId,
        serviceOrderIdToScroll: this.activity.serviceOrderId
      },
      panelClass: 'project-window-dialog'
    });

    dialogRef.afterClosed().subscribe(() => {

    })
  }

  toggleActivity(event) {
    event.originalEvent.stopPropagation()

    this.projectActivityService
      .saveProjectActivity({
        id: this.activity.id,
        ready: this.activity.ready
      })
      .subscribe(() => {
      }, () => {
        this.activity.ready = !this.activity.ready;
      })
  }

  getDuration(duration: number) {
    const totalHours = Math.trunc(duration / 60 / 60)
    const totalMinutes = Math.trunc((duration - totalHours * 60 * 60) / 60)

    return totalHours + 'h:' + totalMinutes + 'm';
  }
}
